export default "__VITE_ASSET__qzRKDzcK__"